import './blogIndex.scss';

const blogIndex = () => {
	$(document).ready(function () {
		var indexContainer = $('#js--index');
		var items = $('.js--index-header');
		if (indexContainer.length == 1 && items.length > 1) {
			var n = 1;
			items.each(function () {
				var id = 'section-index-header-' + n;
				console.log(id);
				var item = $(this);
				item.attr('id', id).addClass('index__header');
				indexContainer.append('<a href="#' + id + '" class="index__item">' + item.text() + '</a>');
				n++;
			});
		}
		indexContainer.prepend('<div class="index__label">' + indexContainer.data('label') + '</div>');
		indexContainer.slideToggle(300);
	});
};

export {blogIndex};




// WEBPACK FOOTER //
// ../components/blogIndex/blogIndex.js